var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEntrepreneurFirst(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 160,
    width: 160,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h160v160H0z",
    fill: "#fff",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#111c51"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 96.727c0-25.216 17.65-45.57 42.812-45.57 24.658 0 41.439 19.453 41.439 47.91v5.044H24.777c1.379 10.987 9.76 20.172 23.802 20.172 7.019 0 16.782-3.242 22.088-8.644l9.588 14.766c-8.218 7.926-21.235 12.069-34.075 12.069-25.173 0-44.18-17.83-44.18-45.747zm42.812-27.379c-13.53 0-19.351 10.626-20.38 19.273H65.19c-.516-8.286-5.996-19.273-20.378-19.273z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.403 139.756V72.851H84.62V52.89h13.783v-4.677C98.403 29.69 109.783 18 126.5 18c7.928 0 16.378 2.157 21.716 8.094l-8.272 13.485c-2.243-2.334-5.172-3.6-9.136-3.6-6.034 0-10.343 4.137-10.343 12.23v4.678h16.892v19.962H120.47v66.907zm31.876-12.502c0-7.972 6.338-14.676 13.859-14.676S158 119.273 158 127.254s-6.338 14.676-13.862 14.676-13.86-6.703-13.86-14.676z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntrepreneurFirst);
export default __webpack_public_path__ + "static/media/entrepreneur-first.4ff3ae3c8505cd499b11ad0f1c998f71.svg";
export { ForwardRef as ReactComponent };